__turbopack_context__.v({
  "container": "MessagesContentCard-module__9eG2sG__container",
  "cta": "MessagesContentCard-module__9eG2sG__cta",
  "desc": "MessagesContentCard-module__9eG2sG__desc",
  "header": "MessagesContentCard-module__9eG2sG__header",
  "icon": "MessagesContentCard-module__9eG2sG__icon",
  "title": "MessagesContentCard-module__9eG2sG__title",
});
